<template>
  <div class="pbl-container">
    <div class="banner">
      <img class="img" :src="$env.imgUrl + 'banner-pbl2.png'" alt="">
      <div class="banner-content">
        <div class="banner-title">学习调研</div>
        <div class="banner-title-en">Program Investigation and Learning</div>
        <div class="banner-tab">
          <div class="banner-tab-item" :class="activeIndex === index ? 'sel' : ''" v-for="(item, index) in tabs" :key="index" @click="handleTabClick(index)">
            <div class="cn">{{ item.title }}</div>
            <div class="en">{{ item.enTitle }}</div>
          </div>
        </div>
      </div>
    </div>
    <study1 v-if="activeIndex === 0"></study1>
    <study2 v-if="activeIndex === 1"></study2>
    <study3 v-if="activeIndex === 2"></study3>
  </div>
</template>
<script>
import study1 from './study/study1.vue'
import study2 from './study/study2.vue'
import study3 from './study/study3.vue'
export default {
  components: {
    study1, study2, study3
  },
  data () {
    return {
      activeIndex: 0,
      tabs: [
        { title: '校内实施路径', enTitle: 'Pathways for Implementing PBL in Schools' },
        { title: '教师成长赋能', enTitle: 'Empowering Teacher Growth' },
        { title: '官方赛前支持', enTitle: 'Official Pre-Match Support' }
      ]
    }
  },
  created() {
    this.activeIndex = this.$route.query.index ? Number(this.$route.query.index) : 0
    this.$store.dispatch('SET_MENUINDEX', 3)
  },
  watch: {
    '$route' (to) {
      this.activeIndex = to.query.index ? Number(to.query.index) : 0
    }
  },
  methods: {
    handleTabClick (index) {
      this.activeIndex = index
      this.$router.replace({ query: { index } })
    }
  }
}
</script>
<style scoped lang="less">
.pbl-container{
  width: 100vw;
  overflow: hidden;
}
.banner{
  width: 100vw;
  position: relative;
  min-height: 300px;
  .img{
    width: 100%;
    height: auto;
    display: block;
  }
  .banner-content{
    position: absolute;
    top: 250px;
    left: 0;
    right: 0;
    text-align: center;
  }
  .banner-title{
    color: #fff;
    font-family: regular;
    font-size: 58px;
    margin-bottom: 10px;
  }
  .banner-title-en{
    color: #fff;
    font-family: alim;
    font-size: 18px;
  }
  .banner-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    .banner-tab-item{
      margin: 20px 10px;
      width: 240px;
      height: 46px;
      border-radius: 46px;
      text-align: center;
      background-color: #fff;
      color: #000;
      cursor: pointer;
      padding-top: 8px;

      .cn{
        font-family: systh;
        font-size: 16px;
        line-height: 20px;
      }
      .en{
        font-family: systm;
        font-size: 10px;
        line-height: 16px;
      }
    }
  }
  .sel{
    background-color: #C92739 !important;
    color: #FFF !important;
  }
}
</style>
